import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/inter';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the service worker to make Vegetablah installable and give it an
// offline-capable app shell. A newer version activates on the next full reload
// (once all tabs are closed) — no forced reload mid-session. See
// src/service-worker.js for the caching policy (API traffic is never cached).
//
// Skip it inside the Capacitor native shell: the Android/iOS app already serves
// its bundle from the local webview, so a precaching SW adds nothing and can
// pin stale assets after an app update (white-screen-on-launch). `window.Capacitor`
// is only injected in the native runtime, so the web PWA is unaffected.
if (!window.Capacitor?.isNativePlatform?.()) {
  serviceWorkerRegistration.register();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
